// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Button from "../../library/Button.bs.js";
import * as Models from "../../../models/Models.bs.js";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Segment from "../../../bindings/Segment.bs.js";
import * as Caml_obj from "@rescript/std/lib/es6/caml_obj.js";
import * as Category from "./Category.bs.js";
import * as Js_option from "@rescript/std/lib/es6/js_option.js";
import * as Js_string from "@rescript/std/lib/es6/js_string.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as RemoteCard from "../../library/RemoteCard.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as SearchInput from "../../library/SearchInput.bs.js";
import * as Router from "next/router";
import * as FilterButton from "../../library/FilterButton.bs.js";
import * as Localization from "../../../config/Localization.bs.js";
import * as CategoriesConf from "../../../config/CategoriesConf.bs.js";
import * as CountriesFilter from "./CountriesFilter.bs.js";
import * as CategoriesFilter from "./CategoriesFilter.bs.js";
import * as BrazeContentCards from "../../library/BrazeContentCards.bs.js";
import * as CardSearchResults from "../../library/CardSearchResults.bs.js";
import * as WallOfCardsStyles from "./WallOfCardsStyles.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as EnrichedTextSection from "../../enrichedTextSection/EnrichedTextSection.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as StoreSmartCardContentTsx from "common/storeSmartCardContent.tsx";

function inventoryToCards(inventory) {
  return Belt_Array.map(inventory.skus, Models.Card.skuToCard);
}

function getCategoryPosition(card, category) {
  return Belt_Option.mapWithDefault(Belt_Array.getBy(card.categories, (function (s) {
                    return s.slug === category;
                  })), 0, (function (c) {
                return c.skuPosition;
              }));
}

function filterCards(cards, category) {
  return Belt_Array.keep(cards, (function (sku) {
                  var cats = Belt_Array.map(sku.categories, (function (c) {
                          return c.slug;
                        }));
                  return Belt_Array.reduce(cats, false, (function (acc, cat) {
                                if (acc) {
                                  return true;
                                } else {
                                  return category.slug === cat;
                                }
                              }));
                })).sort(function (card1, card2) {
              var pos1 = getCategoryPosition(card1, category.slug);
              var pos2 = getCategoryPosition(card2, category.slug);
              if (pos1 > pos2) {
                return 1;
              } else {
                return -1;
              }
            });
}

function getCardLists(param) {
  var cards = param.cards;
  var category = param.category;
  var allCards = Caml_obj.equal(category, CategoriesConf.all) ? cards : filterCards(cards, category);
  return CardSearchResults.getCardLists(param.search, allCards);
}

function removeHiddenCards(cards) {
  return cards.filter(function (card) {
              return !card.isPcCategoryHidden;
            });
}

function WallOfCards(props) {
  var topContent = props.topContent;
  var storeContent = props.storeContent;
  var category = props.category;
  var categories = props.categories;
  var inventoryProps = props.inventoryProps;
  var category$1 = category !== undefined ? category : CategoriesConf.all;
  var defaultStoreContent_smart_card_content = [];
  var defaultStoreContent = {
    smart_card_content: defaultStoreContent_smart_card_content,
    retailer_card_content: undefined,
    end_of_page_content: undefined
  };
  var storeContentDef;
  if (storeContent !== undefined) {
    var c = Caml_option.valFromOption(storeContent);
    storeContentDef = c !== undefined ? c : defaultStoreContent;
  } else {
    storeContentDef = defaultStoreContent;
  }
  var categoryName = category$1.slug === "all" && !Js_option.isNone(storeContentDef.retailer_card_content) ? JsxRuntime.jsx(EnrichedTextSection.make, {
          block: Js_option.getExn(storeContentDef.retailer_card_content),
          wallOfCards: true
        }) : JsxRuntime.jsx("h1", {
          children: Util.ReactStuff.s(category$1.name),
          className: WallOfCardsStyles.title
        });
  var smartCardHero = StoreSmartCardContentTsx.getSmartCardHeroSection(storeContentDef.smart_card_content);
  var smartCardStoreContent = storeContentDef.smart_card_content.length === 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("h2", {
                  children: Util.ReactStuff.s("Prezzee Smart eGift Cards"),
                  className: WallOfCardsStyles.title
                }),
            JsxRuntime.jsxs("h3", {
                  children: [
                    Util.ReactStuff.s("For the ultimate shopping spree wrapped up in one great eGift Card, send a Prezzee Smart eGift Card. It's the ideal swap card that lets your recipient turn it into all the big brand retailer cards. "),
                    Belt_Option.mapWithDefault(Localization.getLocalizedString("Personalise"), null, Util.ReactStuff.s),
                    Util.ReactStuff.s(" it with your own photo and a video message. Perfect gift done!")
                  ],
                  className: WallOfCardsStyles.description
                })
          ]
        }) : StoreSmartCardContentTsx.getEnrichedTextSection(storeContentDef.smart_card_content);
  var endOfPageStoreContent = Js_option.isNone(storeContentDef.end_of_page_content) ? null : JsxRuntime.jsx(EnrichedTextSection.make, {
          block: Js_option.getExn(storeContentDef.end_of_page_content),
          wallOfCards: true
        });
  var isAllCategory = category$1.slug === "all";
  var router = Router.useRouter();
  var searchTerm = Js_dict.get(router.query, "search");
  var searchTimeoutId = {
    contents: setTimeout((function (param) {
            
          }), 0)
  };
  var match = React.useState(function () {
        return true;
      });
  var setFirstload = match[1];
  var firstLoad = match[0];
  var currentInventoryProps = isAllCategory ? removeHiddenCards(inventoryProps) : inventoryProps;
  var topContentBlock;
  if (topContent !== undefined) {
    var c$1 = Caml_option.valFromOption(topContent);
    topContentBlock = c$1 !== undefined ? JsxRuntime.jsx(EnrichedTextSection.make, {
            block: c$1,
            wallOfCards: true
          }) : null;
  } else {
    topContentBlock = null;
  }
  var match$1 = React.useState(function () {
        return Belt_Option.map(searchTerm, (function (s) {
                      var str = decodeURIComponent(s);
                      return Js_string.replaceByRe(/([^\w\s\d])/g, "\\$1", str);
                    }));
      });
  var search = match$1[0];
  var noSearchWords = Belt_Option.getWithDefault(search, "") === "";
  var match$2 = React.useState(function () {
        return getCardLists({
                    search: search,
                    category: category$1,
                    cards: currentInventoryProps
                  });
      });
  var setCardLists = match$2[1];
  var cardLists = match$2[0];
  var allSwapCards = Belt_Array.keepMap(currentInventoryProps, (function (card) {
          if (card.isSwappable) {
            return card;
          }
          
        }));
  var otherCards = Belt_Array.keepMap(currentInventoryProps, (function (card) {
          if (!card.isSwappable) {
            return card;
          }
          
        }));
  var match$3 = React.useState(function () {
        return false;
      });
  var morePanelOpen = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var toggleFilterPanel = match$4[1];
  var filterPanelOpen = match$4[0];
  var openFilterPanel = function (param) {
    Curry._1(toggleFilterPanel, (function (param) {
            return true;
          }));
  };
  React.useEffect((function () {
          Curry._1(setFirstload, (function (param) {
                  return false;
                }));
        }), []);
  React.useEffect((function () {
          Curry._1(toggleFilterPanel, (function (param) {
                  return false;
                }));
          var lists = getCardLists({
                search: search,
                category: category$1,
                cards: currentInventoryProps
              });
          var filteredCards = Belt_Array.keep(lists.filteredCards, (function (c) {
                  if (Belt_Array.some(Belt_Array.map(c.categories, (function (g) {
                                return g.name;
                              })), (function (x) {
                            return x === category$1.name;
                          }))) {
                    return true;
                  } else {
                    return category$1.slug === "all";
                  }
                }));
          var products = Belt_Array.mapWithIndex(filteredCards, Segment.cardToProductWithIndex);
          Curry._1(setCardLists, (function (param) {
                  return lists;
                }));
          searchTimeoutId.contents = setTimeout((function (param) {
                  var isHomeSearch = Belt_Option.isSome(searchTerm) && firstLoad;
                  if (Belt_Option.getWithDefault(search, "").length > 0) {
                    Segment.productsSearched({
                          query: search,
                          search_count: filteredCards.length,
                          products: products,
                          search_location: isHomeSearch ? "home" : "store"
                        });
                  }
                  if (allSwapCards.length !== 0 && Belt_Option.getWithDefault(search, "") === "" && category$1.slug === "all") {
                    var products$1 = Belt_Array.mapWithIndex(allSwapCards, Segment.cardToProductWithIndex);
                    Segment.productListViewed({
                          list_id: "catalogue-promo",
                          category: "Featured",
                          products: products$1
                        });
                  }
                  if (lists.filteredCards.length !== 0) {
                    return Segment.productListViewed({
                                list_id: "catalogue-main",
                                category: category$1.name,
                                products: products
                              });
                  }
                  
                }), 1000);
          return (function (param) {
                    clearTimeout(searchTimeoutId.contents);
                  });
        }), [
        category$1,
        search
      ]);
  var hasSwapCards = allSwapCards.length !== 0;
  var hasCards = cardLists.filteredCards.length !== 0;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("button", {
                                      children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                            icon: [
                                              "fas",
                                              "times"
                                            ]
                                          }),
                                      className: Cn.make([
                                            Button.blueCircleStyle,
                                            "h-6 w-6 text-white flex items-center justify-center absolute right-0 top-0 z-10 mt-4 mr-4 sm:hidden"
                                          ]),
                                      onClick: (function (e) {
                                          e.preventDefault();
                                          Curry._1(toggleFilterPanel, (function (param) {
                                                  return false;
                                                }));
                                        })
                                    }),
                                JsxRuntime.jsx(CategoriesFilter.make, {
                                      productTypeCategories: categories,
                                      selectedCategory: category$1,
                                      morePanelOpen: morePanelOpen,
                                      toggleMorePanel: match$3[1],
                                      className: "w-full my-2 sm:w-4/7 md:w-5/8 lg:w-8/11 xl:w-11/14 xxl:w-13/16"
                                    }),
                                JsxRuntime.jsx(CountriesFilter.make, {
                                      countryCategories: CategoriesConf.categoriesByCountry,
                                      className: "w-full my-2 sm:border-l-2 sm:border-t-0 sm:border-b-0 border-gray-200 sm:w-3/7 md:w-3/8 lg:w-3/11 xl:w-3/14 xxl:w-3/16 mx-auto mb-20 sm:mb-0"
                                    })
                              ],
                              className: "xl:container sm:flex items-stretch justify-center mx-auto select-none overflow-scroll sm:overflow-visible h-full"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: morePanelOpen ? JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("div", {
                                                          children: Belt_Array.mapWithIndex(categories, (function (i, cat) {
                                                                  var isHiddenAtSize = function (size) {
                                                                    return Belt_Array.keep(cat.screens, (function (c) {
                                                                                  return c === size;
                                                                                })).length === 1;
                                                                  };
                                                                  var classes = Cn.make([
                                                                        "w-1/3",
                                                                        isHiddenAtSize("xs") ? "xs:hidden" : "",
                                                                        isHiddenAtSize("sm") ? "sm:hidden" : "",
                                                                        isHiddenAtSize("md") ? "md:hidden" : "",
                                                                        isHiddenAtSize("lg") ? "lg:hidden" : "",
                                                                        isHiddenAtSize("xl") ? "xl:hidden" : "",
                                                                        isHiddenAtSize("xxl") ? "xxl:hidden" : ""
                                                                      ]);
                                                                  return JsxRuntime.jsx("div", {
                                                                              children: JsxRuntime.jsx(Category.make, {
                                                                                    category: cat,
                                                                                    selectedCategory: category$1
                                                                                  }),
                                                                              className: classes
                                                                            }, "category-" + String(i));
                                                                })),
                                                          className: "flex flex-wrap p-3 border-0 border-t-1 border-dotted"
                                                        }),
                                                    className: "absolute right-0 top-0 z-10 border-1 border-t-0 bg-white shadow-lg w-80 rounded-b-md xxl:hidden"
                                                  }) : null,
                                            className: "bg-prezzee-red relative"
                                          }),
                                      className: "sm:w-4/7 md:w-5/8 lg:w-8/11 xl:w-11/14 xxl:w-13/16"
                                    }),
                                JsxRuntime.jsx("div", {
                                      className: "sm:w-3/7 md:w-3/8 lg:w-3/11 xl:w-3/14 xxl:w-3/16"
                                    })
                              ],
                              className: "xl:container lg:flex items-center justify-center mx-auto select-none"
                            })
                      ],
                      className: Cn.make([
                            filterPanelOpen ? "overflow-hidden" : "hidden",
                            "fixed w-full h-full z-20 sm:relative sm:block pt-1 mb-4 xl:px-10 bg-white shadow-lg"
                          ])
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(SearchInput.make, {
                                              setSearch: match$1[1],
                                              defaultValue: Belt_Option.getWithDefault(searchTerm, ""),
                                              className: "flex-1 relative",
                                              trackSearchReset: (function (param) {
                                                  Segment.customElementInteraction({
                                                        element: "clear_search",
                                                        journey: "classic_product_search"
                                                      });
                                                })
                                            }),
                                        JsxRuntime.jsx(FilterButton.make, {
                                              onFilterClick: openFilterPanel
                                            })
                                      ],
                                      className: "flex flex-nowrap w-full text-gray-600 pt-5 px-2 md:px-4"
                                    }),
                                noSearchWords ? JsxRuntime.jsx(BrazeContentCards.make, {}) : null,
                                noSearchWords ? (
                                    hasSwapCards && hasCards && category$1.slug === "all" ? JsxRuntime.jsxs("div", {
                                            children: [
                                              smartCardHero,
                                              smartCardStoreContent,
                                              JsxRuntime.jsx("div", {
                                                    children: Belt_Array.mapWithIndex(allSwapCards, (function (i, card) {
                                                            return JsxRuntime.jsx(RemoteCard.make, {
                                                                        card: card
                                                                      }, "eGifCard_" + String(i));
                                                          })),
                                                    className: WallOfCardsStyles.cardsContainer
                                                  })
                                            ]
                                          }) : null
                                  ) : (
                                    hasSwapCards ? (
                                        hasCards ? JsxRuntime.jsx("h2", {
                                                children: Util.ReactStuff.s("Your search results"),
                                                className: WallOfCardsStyles.title
                                              }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                children: [
                                                  JsxRuntime.jsx("h2", {
                                                        children: Util.ReactStuff.s("Prezzee Smart eGift Cards"),
                                                        className: WallOfCardsStyles.title
                                                      }),
                                                  JsxRuntime.jsx("h3", {
                                                        children: Util.ReactStuff.s("Your search has yielded no results. so why not consider the Prezzee Smart eGift Card which can be used to unlock our wall of retailer eGift Cards"),
                                                        className: WallOfCardsStyles.description
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: Belt_Array.mapWithIndex(allSwapCards, (function (i, card) {
                                                                return JsxRuntime.jsx(RemoteCard.make, {
                                                                            card: card
                                                                          }, "eGifCard_" + String(i));
                                                              })),
                                                        className: WallOfCardsStyles.cardsContainer
                                                      })
                                                ]
                                              })
                                      ) : null
                                  )
                              ]
                            }),
                        JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                Belt_Option.getWithDefault(search, "").length === 0 ? (
                                    topContentBlock === null ? categoryName : topContentBlock
                                  ) : null,
                                JsxRuntime.jsx("div", {
                                      children: category$1.slug === "all" && Belt_Option.getWithDefault(search, "") === "" ? Belt_Array.mapWithIndex(otherCards, (function (i, card) {
                                                return JsxRuntime.jsx(RemoteCard.make, {
                                                            card: card
                                                          }, card.uid);
                                              })) : Belt_Array.mapWithIndex(cardLists.filteredCards, (function (i, card) {
                                                return JsxRuntime.jsx(RemoteCard.make, {
                                                            card: card
                                                          }, card.uid);
                                              })),
                                      className: WallOfCardsStyles.cardsContainer
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(CardSearchResults.SimilarResults.make, {
                                            cardLists: cardLists,
                                            className: "mt-4"
                                          }),
                                      className: WallOfCardsStyles.similarResultsContainer
                                    })
                              ]
                            }),
                        endOfPageStoreContent,
                        noSearchWords ? null : JsxRuntime.jsx(BrazeContentCards.make, {})
                      ],
                      className: WallOfCardsStyles.rootContainerWall
                    })
              ],
              className: Cn.make([
                    filterPanelOpen ? "overflow-hidden bg-white" : "",
                    "relative bg-white"
                  ])
            });
}

var SkuPresentation;

var make = WallOfCards;

export {
  SkuPresentation ,
  inventoryToCards ,
  getCategoryPosition ,
  filterCards ,
  getCardLists ,
  removeHiddenCards ,
  make ,
}
/* Util Not a pure module */
